import { Component, effect, ElementRef, input, output, Renderer2, ViewChild } from '@angular/core';
import { Select2ScrollEvent, Select2SearchEvent } from 'ng-select2-component';
import { addSelectedValues, getExpeditionsByRouteId, getRoutesByServiceInfo, getServiceInfos, searchUsers } from 'src/app/forms/messageForms';
import { IBase, IClient, ITown, IUser } from 'src/app/models';
import { CommunicationUserType, InputType, UserRole, UserType } from 'src/app/models/enums';
import { MessageReceiver } from 'src/app/models/enums/messageReceiver';
import { LiteralService, MessageService, RouteService, StorageService, TownsService, TripsService, UsersService, UtilsService } from 'src/app/services';
import { ServiceInfoService } from 'src/app/services/service-info/service-info.service';
import { images } from 'src/images';

@Component({
  selector: 'app-message-filter',
  templateUrl: './message-filter.component.html',
  styleUrl: './message-filter.component.scss',
  standalone: false
})
export class MessageFilterComponent {

  private initialized = false;

  readonly isFilterOpen = input<boolean>();
  readonly componentOpen = input<string>();
  readonly communicationUserType = input<CommunicationUserType>();
  readonly filter = output<any>();
  readonly closeFilter = output();

  @ViewChild('select') select: ElementRef;

  adminRole: UserRole;
  
  clients: IClient[] = [];
  towns: any[] = [];
  selectedValuesClients: any[] = [];

  senders: any[] = [];
  selectedSenders: any[] = [];

  receivers: any[] = [];
  selectedReceiver: any = null;

  page = 1;
  receiverElement: any = {
    id: 'receiver',
    value: [],
    edit: {
      editable: true,
      inputType: InputType.MULTISELECT_SCROLL,
      values: [],
      valueToChange: 'receiver',
      customSearchEnabled: true
    }
  };

  servicesPage = 1;
  expeditionServicesElement: any = {
    id: 'expeditionServices',
    value: undefined,
    edit: {
      editable: true,
      inputType: InputType.INFINITE_SCROLL,
      values: [],
      valueToChange: 'expeditionService',
      customSearchEnabled: true
    }
  };

  expeditionsPage = 1;

  routesPage = 1;
  expeditionRoutesElement: any = {
    id: 'expeditionRoute',
    value: undefined,
    edit: {
      editable: true,
      inputType: InputType.INFINITE_SCROLL,
      values: [],
      valueToChange: 'expeditionRoute',
      customSearchEnabled: true,
      disabled: true
    }
  };

  searchValue: string = '';

  public images = images;
  public UserRoles = UserRole;
  public MessageReceiver = MessageReceiver;

  constructor(
    renderer: Renderer2,
    public literalService: LiteralService,
    public utilsService: UtilsService,
    public storageService: StorageService,
    public usersService: UsersService,
    public messageService: MessageService,
    public townsService: TownsService,
    public serviceInfoService: ServiceInfoService,
    public routeService: RouteService,
    public tripsService: TripsService
  ) {
    renderer.listen('window', 'click', (e: Event) => {
      const modal = document.getElementById('filterContainer')!;
      const componentOpen = document.getElementById(this.componentOpen()!)!;
      const close = utilsService.closeCustomModals(e, modal, componentOpen);
      if (close) {
        this.closeFilter.emit();
      }
    });

    effect(() => {
      if (this.isFilterOpen() && !this.initialized) {
        this.initialized = true;
        this.initFilterValues();
      }
    });
  }

  initFilters() {
    this.storageService.getMessagesFilters().then(async (savedFilters) => {
      if (savedFilters) {
        const selectedFilters = JSON.parse(savedFilters);
        this.selectedValuesClients = selectedFilters.selectedClients;
        this.selectedSenders = selectedFilters.selectedSenders;

        this.selectedReceiver = selectedFilters.receivers.selectedReceiver;
        await this.updateReceiverValues(this.selectedReceiver);
        if (this.selectedReceiver === MessageReceiver.EXPEDITION) {
          this.expeditionServicesElement.value = selectedFilters.receivers.selectedExpeditionService;
          if (this.expeditionServicesElement.value) {
            this.expeditionRoutesElement.edit.disabled = false;
          }
          setTimeout(() => {
            this.expeditionRoutesElement.value = selectedFilters.receivers.selectedExpeditionRoute;
            if (this.expeditionRoutesElement.value) {
              this.receiverElement.edit.disabled = false;
            }
            this.receiverElement.value = selectedFilters.receivers.selectedReceivers;
          });
        } else {
          this.receiverElement.value = selectedFilters.receivers.selectedReceivers;
        }
      }
    });
  }

  initFilterValues() {
    this.storageService.getRole().then((role) => {
      this.adminRole = role;
      this.usersService.getPossibleClientTowns().then((res: any) => {
        res.clients.map((client: IClient) => {
          this.clients.push({
            id: client.id,
            code: client.code,
            name: client.name,
          });
        });
        res.towns.map((town: ITown) => {
          this.towns.push({
            id: town.id,
            value: town,
            label: town.name,
          });
        });
      })
  
      const receiverValues: any[] = [];
      Object.values(MessageReceiver).forEach((receiver: MessageReceiver) => {
        if (this.communicationUserType() === CommunicationUserType.USERS && receiver === MessageReceiver.DRIVER ) return;
        if (this.communicationUserType() === CommunicationUserType.DRIVERS && (receiver === MessageReceiver.USER || receiver === MessageReceiver.TOWN || receiver === MessageReceiver.SERVICE)) return;
        if ((this.adminRole != UserRole.SUPERADMIN && this.adminRole != UserRole.ADMIN) && (receiver === MessageReceiver.TOWN || receiver === MessageReceiver.SERVICE)) return;
        receiverValues.push({
          id: receiver,
          value: receiver,
          label: this.literalService.get(`messages.receiver.${receiver.toLowerCase()}`, true)
        })
      });
      this.receivers = structuredClone(receiverValues);
  
      this.messageService.getSenders(this.communicationUserType()!!).then((res: any) => {
        res.map((sender: any) => {
          this.senders.push({
            id: sender.id,
            code: `${sender.firstName} ${sender.lastName}`,
            name: `${sender.firstName} ${sender.lastName}`
          });
        })
      });
  
      this.initFilters();
    })
  }

  changeData(data: any, element: string) {
    switch(element) {
      case 'receiverType':
        this.selectedReceiver = data.value;
        this.receiverElement.edit.values = [];
        this.receiverElement.value = [];
        this.expeditionServicesElement.edit.values = [];
        this.expeditionServicesElement.value = undefined;
        this.expeditionRoutesElement.edit.values = [];
        this.expeditionRoutesElement.value = undefined;
        if (data.value === MessageReceiver.EXPEDITION) {
          this.expeditionRoutesElement.edit.disabled = true;
          this.receiverElement.edit.disabled = true;
        }
        this.updateReceiverValues(data.value as MessageReceiver);
        break;
      case 'receiver':
        this.receiverElement.value = data;
        break;
      case 'expeditionService':
        this.expeditionServicesElement.value = data;
        this.receiverElement.edit.values = [];
        this.receiverElement.value = [];
        this.expeditionRoutesElement.edit.values = [];
        this.expeditionRoutesElement.value = undefined;
        this.expeditionRoutesElement.edit.disabled = true;
        this.receiverElement.edit.disabled = true;
        this.updateReceiverValues(this.selectedReceiver);
        break;
      case 'expeditionRoute':
        this.expeditionRoutesElement.value = data;
        this.receiverElement.edit.values = [];
        this.receiverElement.value = [];
        this.receiverElement.edit.disabled = true;
        this.updateReceiverValues(this.selectedReceiver);
        break;
    }
  }

  async updateReceiverValues(type: MessageReceiver) {
    if (type !== MessageReceiver.EXPEDITION) {
      this.receiverElement.edit.disabled = false;
      this.receiverElement.edit.inputType = InputType.MULTISELECT_SCROLL;
    }
    switch(type) {
      case MessageReceiver.USER:
        this.page = 1;
        this.receiverElement.edit.customSearchEnabled = true;
        this.receiverElement.edit.values = await this.getUsers(UserType.Regular, this.receiverElement.edit.values, this.receiverElement.value);
        this.receiverElement.edit.placeholder = this.literalService.get('messages.receiver.user', true);
        break;
      case MessageReceiver.DRIVER:
        this.page = 1;
        this.receiverElement.edit.customSearchEnabled = true;
        this.receiverElement.edit.values = await this.getUsers(UserType.Driver, this.receiverElement.edit.values, this.receiverElement.value);
        this.receiverElement.edit.placeholder = this.literalService.get('messages.receiver.driver', true);
        break;
      case MessageReceiver.TOWN:
        this.page = 1;
        this.receiverElement.value = [];
        this.receiverElement.edit.values = this.towns;
        this.receiverElement.edit.customSearchEnabled = false;
        this.receiverElement.edit.placeholder = this.literalService.get('messages.receiver.town', true);
        break;
      case MessageReceiver.SERVICE:
        this.page = 1;
        this.receiverElement.edit.customSearchEnabled = true;
        this.receiverElement.edit.placeholder = this.literalService.get('messages.receiver.service', true);
        this.receiverElement.edit.values = await this.getServiceInfos(this.receiverElement.edit.values, this.page);
        break;
      case MessageReceiver.EXPEDITION:
        this.expeditionServicesElement.edit.placeholder = this.literalService.get('messages.receiver.service', true);
        this.expeditionRoutesElement.edit.placeholder = this.literalService.get('messages.receiver.routes', true);
        this.receiverElement.edit.placeholder = this.literalService.get('messages.receiver.expedition', true);
        this.receiverElement.edit.inputType = InputType.INFINITE_SCROLL;
        this.receiverElement.edit.customSearchEnabled = true;
        if (this.expeditionRoutesElement.value) {
          this.receiverElement.edit.disabled = true;
          this.expeditionsPage = 1;
          this.receiverElement.edit.values = await this.getExpeditions(this.expeditionRoutesElement.value.id, this.expeditionsPage, 10);
          this.receiverElement.edit.disabled = false;
        } else if (this.expeditionServicesElement.value) {
          this.expeditionRoutesElement.edit.disabled = true;
          this.receiverElement.edit.disabled = true;
          this.routesPage = 1;
          this.expeditionRoutesElement.value = undefined;
          this.expeditionRoutesElement.edit.values = await this.getRoutesByServiceInfo(this.expeditionRoutesElement.edit.values);
          this.expeditionRoutesElement.edit.disabled = false;
        } else {
          this.expeditionRoutesElement.edit.disabled = true;
          this.receiverElement.edit.disabled = true;
          this.servicesPage = 1;
          this.expeditionServicesElement.edit.values = await getServiceInfos(this.serviceInfoService, undefined, '', this.page);
        }
        break;
    }
    this.receiverElement.edit.values = addSelectedValues(this.utilsService, this.receiverElement.edit.values, this.receiverElement.value);
  }

  async search(event: Select2SearchEvent, valueToChange: string) {
    this.searchValue = event.search;
    const dropDown = document.getElementsByClassName('select2-results__options')[0];
    if (valueToChange === 'receiver') {
      switch(this.selectedReceiver) {
        case MessageReceiver.USER:
          this.page = 1;
          this.receiverElement.edit.values = await this.getUsers(UserType.Regular, this.receiverElement.edit.values, this.receiverElement.value, false, this.searchValue);
          break;
        case MessageReceiver.DRIVER:
          this.page = 1;
          this.receiverElement.edit.values = await this.getUsers(UserType.Driver, this.receiverElement.edit.values, this.receiverElement.value, false, this.searchValue);
          break;
        case MessageReceiver.SERVICE:
          this.page = 1;
          this.receiverElement.edit.values = await this.getServiceInfos(this.receiverElement.edit.values, this.page, false, this.searchValue);
          break;
        case MessageReceiver.EXPEDITION:
          this.expeditionsPage = 1;
          this.receiverElement.edit.values = await this.getExpeditions(this.expeditionRoutesElement.value.id, this.expeditionsPage, 10, false, this.searchValue);
          break;
      }
    } else if (valueToChange === 'expeditionService') {
      this.servicesPage = 1;
      this.expeditionServicesElement.edit.values = await this.getServiceInfos(this.receiverElement.edit.values, this.servicesPage, false, this.searchValue);
      this.expeditionServicesElement.edit.values = addSelectedValues(this.utilsService, this.expeditionServicesElement.edit.values, [this.expeditionServicesElement.value]);
    } else if (valueToChange === 'expeditionRoute') {
      this.routesPage = 1;
      this.expeditionRoutesElement.edit.values = await this.getRoutesByServiceInfo(this.expeditionRoutesElement.edit.values, false, this.searchValue);
      this.expeditionRoutesElement.edit.values = addSelectedValues(this.utilsService, this.expeditionRoutesElement.edit.values, [this.expeditionRoutesElement.value]);
    }
    this.receiverElement.edit.values = addSelectedValues(this.utilsService, this.receiverElement.edit.values, this.receiverElement.value);
    dropDown.scroll({
      top: 0
    });
  }

  async scroll(event: Select2ScrollEvent, valueToChange: string) {
    if (event.way === 'down') {
      if (valueToChange === 'receiver') {
        switch(this.selectedReceiver) {
          case MessageReceiver.USER:
            this.page += 1;
            this.receiverElement.edit.values = await this.getUsers(UserType.Regular, this.receiverElement.edit.values, this.receiverElement.value, true, this.searchValue);
            break;
          case MessageReceiver.DRIVER:
            this.page += 1;
            this.receiverElement.edit.values = await this.getUsers(UserType.Driver, this.receiverElement.edit.values, this.receiverElement.value, true, this.searchValue);
            break;
          case MessageReceiver.SERVICE:
            this.page += 1;
            this.receiverElement.edit.values = await this.getServiceInfos(this.receiverElement.edit.values, this.page, true, this.searchValue);
            break;
          case MessageReceiver.EXPEDITION:
            this.expeditionsPage += 1;
            this.receiverElement.edit.values = await this.getExpeditions(this.expeditionRoutesElement.value.id, this.expeditionsPage, 10, true, this.searchValue);
            break;
        }
      } else if (valueToChange === 'expeditionRoute') {
        this.routesPage += 1;
        this.expeditionRoutesElement.edit.values = await this.getRoutesByServiceInfo(this.expeditionRoutesElement.edit.values, true, this.searchValue);
      } else if (valueToChange === 'expeditionService') {
        this.servicesPage += 1;
        this.expeditionServicesElement.edit.values = await this.getServiceInfos(this.expeditionServicesElement.edit.values, this.servicesPage, true, this.searchValue);
      }
      this.receiverElement.edit.values = addSelectedValues(this.utilsService, this.receiverElement.edit.values, this.receiverElement.value);
    }
  }

  async getUsers(userType: UserType, currentListValue: any, selectedValues: any, showMore?: boolean, searchValue?: string) {
    let list: any[] = [];
    const users = await searchUsers(this.usersService, this.utilsService, userType, undefined, searchValue, selectedValues, this.page);
    if (showMore && !searchValue) {
      list = [
        ...currentListValue,
        ...users
      ]
    } else {
      list = users;
    }
    return list;
  }

  async getServiceInfos(currentListValue: any, specificPage: number, showMore?: boolean, searchValue?: string) {
    let list: any[] = [];
    const serviceInfos = await getServiceInfos(this.serviceInfoService, undefined, searchValue, specificPage);
    if (showMore && !searchValue) {
      list = [
        ...currentListValue,
        ...serviceInfos
      ]
    } else {
      list = serviceInfos;
    }
    return list;
  }

  async getRoutesByServiceInfo(currentListValue: any, showMore?: boolean, searchValue?: string) {
    let list: any[] = [];
    const routes = await getRoutesByServiceInfo(this.routeService, this.expeditionServicesElement.value.id, searchValue, this.routesPage);
    if (showMore && !searchValue) {
      list = [
        ...currentListValue,
        ...routes
      ]
    } else {
      list = routes;
    }
    return list;
  }

  async getExpeditions(routeId: number, page: number, size: number, showMore?: boolean, searchValue?: string) {
    const newValues = await getExpeditionsByRouteId(this.tripsService, routeId, [], page, size, searchValue);
    if (showMore) {
      return [...this.receiverElement.edit.values, ...newValues];
    }
    return newValues;
  }

  selectAll(event: any) {
    if (event.currentTarget.checked) {
      this.clients.map((client: IClient) => this.selectedValuesClients.push(client));
      this.senders.map((sender: any) => this.selectedSenders.push(sender));
    }
  }

  clearSelection() {
    this.selectedValuesClients = [];
    this.selectedSenders = [];

    this.selectedReceiver = undefined;
    this.expeditionServicesElement.value = undefined;
    this.expeditionRoutesElement.value = undefined;
    this.receiverElement.value = [];

    if (this.select) this.select.nativeElement.checked = false;
  }

  onSubmit() {
    const selectedClients: IBase[] = [];
    this.selectedValuesClients.length > 0 && this.selectedValuesClients.forEach((client: IClient) => {
      selectedClients.push(client);
    });

    const selectedSenders: IBase[] = [];
    this.selectedSenders.length > 0 && this.selectedSenders.forEach((sender: IUser) => {
      selectedSenders.push(sender);
    });

    const selectedReceivers: IBase[] = [];
    if (this.receiverElement.value) {
      if (Array.isArray(this.receiverElement.value)) {
        this.receiverElement.value.forEach((receiver: IBase) => {
          selectedReceivers.push(receiver);
        });
      } else {
        selectedReceivers.push(this.receiverElement.value);
      }
    }

    this.storageService.setMessagesFilters(JSON.stringify({
      selectedClients,
      selectedSenders,
      receivers: selectedReceivers.length > 0 ? {
        selectedReceiver: this.selectedReceiver,
        selectedExpeditionService: this.expeditionServicesElement.value,
        selectedExpeditionRoute: this.expeditionRoutesElement.value,
        selectedReceivers,
      } : []
    }));

    this.filter.emit({
      selectedClients,
      selectedSenders,
      receivers: {
        selectedReceivers
      }
    });
  }

}
